var quizQuestions = [
    {
        "id": 39,
        "question": "  Who were the first to circle the moon?",
        "answers": [
            {
                "id": 153,
                "option": "  Frank boreman, Bill Anders and Jim Lovell"
            },
            {
                "id": 154,
                "option": "  Neil Armstrong and Edwin Aldrin"
            },
            {
                "id": 155,
                "option": "  Charles Conrad and Alan Bean"
            },
            {
                "id": 156,
                "option": "  None of these"
            }
        ],
        "answer": {
            "id": 39,
            "option": {
                "id": 153,
                "option": "  Frank boreman, Bill Anders and Jim Lovell"
            }
        }
    },
    {
        "id": 11,
        "question": "  Which of the following in the book/play written by Maithili Sharan Gupt?",
        "answers": [
            {
                "id": 41,
                "option": "  Saket"
            },
            {
                "id": 42,
                "option": "  Satyartha Prakash"
            },
            {
                "id": 43,
                "option": "  Shakuntala"
            },
            {
                "id": 44,
                "option": "  Savitri"
            }
        ],
        "answer": {
            "id": 11,
            "option": {
                "id": 41,
                "option": "  Saket"
            }
        }
    },
    {
        "id": 19,
        "question": "  Which of he following is he author of play/book ?Yashodhara?:",
        "answers": [
            {
                "id": 73,
                "option": "  Maithili Sharan Gupt"
            },
            {
                "id": 74,
                "option": "  Khushwant Singh"
            },
            {
                "id": 75,
                "option": "  Bankimchandra Chatterjee"
            },
            {
                "id": 76,
                "option": "  Sarojini Naidu"
            }
        ],
        "answer": {
            "id": 19,
            "option": {
                "id": 73,
                "option": "  Maithili Sharan Gupt"
            }
        }
    },
    {
        "id": 31,
        "question": "  Who landed on the mainland of South America for the First time?",
        "answers": [
            {
                "id": 121,
                "option": "  Discovered Greenland"
            },
            {
                "id": 122,
                "option": "  Landed on the mainland of south America"
            },
            {
                "id": 123,
                "option": "  Discovered the sea route from Europe to India"
            },
            {
                "id": 124,
                "option": "  None of these"
            }
        ],
        "answer": {
            "id": 31,
            "option": {
                "id": 122,
                "option": "  Landed on the mainland of south America"
            }
        }
    },
    {
        "id": 23,
        "question": "  Fa-hien was:",
        "answers": [
            {
                "id": 89,
                "option": "  The first Buddhist pilgrim of China to visit India during the reign of Chandragupta Vikramaditya"
            },
            {
                "id": 90,
                "option": "  The discover of Puerto Rico and Jamaica"
            },
            {
                "id": 91,
                "option": "  The first Buddhist pilgrim of India to visit China"
            },
            {
                "id": 92,
                "option": "  None of these"
            }
        ],
        "answer": {
            "id": 23,
            "option": {
                "id": 89,
                "option": "  The first Buddhist pilgrim of China to visit India during the reign of Chandragupta Vikramaditya"
            }
        }
    },
    {
        "id": 25,
        "question": "  Who is also known as the ?Lady with the Lamp??",
        "answers": [
            {
                "id": 97,
                "option": "  Florence Nightingale"
            },
            {
                "id": 98,
                "option": "  Sarojini Naidu"
            },
            {
                "id": 99,
                "option": "  Rani Laxmibai"
            },
            {
                "id": 100,
                "option": "  Bachendri Pal"
            }
        ],
        "answer": {
            "id": 25,
            "option": {
                "id": 97,
                "option": "  Florence Nightingale"
            }
        }
    },
    {
        "id": 40,
        "question": "  ?Arena? is the special name for playground of:",
        "answers": [
            {
                "id": 157,
                "option": "  Cricket"
            },
            {
                "id": 158,
                "option": "  Lawn Tennis"
            },
            {
                "id": 159,
                "option": "  Wrestling"
            },
            {
                "id": 160,
                "option": "  Skating"
            }
        ],
        "answer": {
            "id": 40,
            "option": {
                "id": 159,
                "option": "  Wrestling"
            }
        }
    },
    {
        "id": 42,
        "question": "  Badminton is the national sport at:",
        "answers": [
            {
                "id": 165,
                "option": "  Malaysia"
            },
            {
                "id": 166,
                "option": "  Scotland"
            },
            {
                "id": 167,
                "option": "  China"
            },
            {
                "id": 168,
                "option": "  Former soviet Union"
            }
        ],
        "answer": {
            "id": 42,
            "option": {
                "id": 165,
                "option": "  Malaysia"
            }
        }
    },
    {
        "id": 32,
        "question": "  Who was first to sail sound the strait, reached the Philippines and named the Pacific Ocean?",
        "answers": [
            {
                "id": 125,
                "option": "  Ferdinand Magelion"
            },
            {
                "id": 126,
                "option": "  Jacques Carter"
            },
            {
                "id": 127,
                "option": "  William Janszoom"
            },
            {
                "id": 128,
                "option": "  Vasco da Gama"
            }
        ],
        "answer": {
            "id": 32,
            "option": {
                "id": 125,
                "option": "  Ferdinand Magelion"
            }
        }
    },
    {
        "id": 43,
        "question": "  Where is the Vallabhbhai Patel stadium located?",
        "answers": [
            {
                "id": 169,
                "option": "  Kolkata"
            },
            {
                "id": 170,
                "option": "  Mumbai"
            },
            {
                "id": 171,
                "option": "  Chennai"
            },
            {
                "id": 172,
                "option": "  Delhi"
            }
        ],
        "answer": {
            "id": 43,
            "option": {
                "id": 170,
                "option": "  Mumbai"
            }
        }
    }
];

export default quizQuestions;



// WEBPACK FOOTER //
// ./react/app/api/quizQuestions.js